export default "__VITE_ASSET__DEHSX1Ze__"